/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type UserType = (typeof UserType)[keyof typeof UserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserType = {
	staff: 'staff',
	physician: 'physician',
} as const;
